import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import get from 'lodash/get';
import withHostContext, {
  trackingLocations,
  trackClick,
} from '../../../context/host/consumer';
import { cleanUpHTMLText } from '../../../utils/strings';
import SanitizeHTML from '../../../components/SanitizedHTML';
import './styles.css';
import QuickFacts from '../QuickFacts';

const messages = defineMessages({
  schoolMore: {
    id: 'hubs.profiles.more-about-school',
    defaultMessage: 'More about this college:',
  },
  knowCollege: {
    id: 'hubs.overview.school-profile-get-to-know',
    defaultMessage: 'Get to know the college',
  },
  learnMoreAboutCollege: {
    id: 'hubs.overview.learn-more-about-college-profile',
    defaultMessage: 'Learn more about {college}.',
  },
});

class SchoolProfile extends React.PureComponent {
  static propTypes = {
    schoolProfile: PropTypes.object,
    fullProfile: PropTypes.object,
    intl: PropTypes.object,
  };

  constructor(props) {
    super(props);
    const { schoolProfile } = this.props;
    const productId = get(schoolProfile, 'product_id');
    if (productId) {
      trackClick(this.props.hostContext, {
        productId,
        location: trackingLocations.ABOUT_US,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { schoolProfile } = this.props;
    const productId = get(schoolProfile, 'product_id');
    if (productId && productId !== get(prevProps, 'schoolProfile.product_id')) {
      trackClick(this.props.hostContext, {
        productId,
        location: trackingLocations.ABOUT_US,
      });
    }
  }

  render() {
    const { schoolProfile, fullProfile, intl, hostContext } = this.props;
    const collegeName = get(fullProfile, 'overview.schoolName.value', '');
    const openingStatement = get(fullProfile, 'overview.openingStatement.value');
    const headline = get(schoolProfile, 'headline', '');
    const isCamino = get(hostContext, 'isCamino', false);
    return (
      <div className="school-profile-container common-core-width">
        <h2 data-cy="profile-heading" className="school-profile-heading" tabIndex="0">
          <FormattedMessage {...messages.knowCollege} />
        </h2>
        {!isCamino && (
          <p
            data-cy="profile-learn-more"
            className="school-profile-learn-more"
            tabIndex="0"
            data-navi-donottranslate
          >
            <FormattedMessage
              {...messages.learnMoreAboutCollege}
              values={{
                college: collegeName,
              }}
            />
          </p>
        )}

        {schoolProfile && (
          <div className="school-profile">
            <div
              className="image-container"
              style={{
                backgroundPosition: '50% 50%',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundImage: `url("${schoolProfile.img}")`,
              }}
            >
              {schoolProfile.img && (
                <img
                  className="image"
                  src={schoolProfile.img}
                  alt={cleanUpHTMLText(headline, true)}
                ></img>
              )}
            </div>
            <div className="school-profile-details">
              <h3 data-cy="name" className="name" tabIndex="0" aria-label="name">
                {cleanUpHTMLText(headline, true)}
              </h3>
              {schoolProfile.quote && (
                <div data-cy="quote" className="quote" tabIndex="0" aria-label="quote">
                  {'“'}
                  <SanitizeHTML html={cleanUpHTMLText(schoolProfile.quote, true)} />
                  {'“'}
                </div>
              )}
            </div>

            <div className="more-info-container">
              <div className="body">
                <div data-cy="more-info-heading" className="more-info-body-heading">
                  <FormattedMessage {...messages.schoolMore} />
                </div>
                <div
                  data-cy="more-info-body-content"
                  className="more-info-body-content"
                  tabIndex="0"
                  aria-label={intl.formatMessage(messages.schoolMore)}
                >
                  <SanitizeHTML html={cleanUpHTMLText(schoolProfile.body, true)} />
                </div>
              </div>
            </div>
            <QuickFacts fullProfile={fullProfile} isCamino={isCamino}></QuickFacts>
          </div>
        )}
        {!schoolProfile && (
          <div className="non-profile-container">
            {openingStatement && (
              <div className="opening-statement">{openingStatement}</div>
            )}
            <QuickFacts fullProfile={fullProfile} isCamino={isCamino}></QuickFacts>
          </div>
        )}
      </div>
    );
  }
}

export default injectIntl(withHostContext(SchoolProfile));
